// extracted by mini-css-extract-plugin
export default {"timeSlot":"TimeSlot_timeSlot__71pNs","timeSlotContainer":"TimeSlot_timeSlotContainer__C-7yP","card":"TimeSlot_card__tVsNq","activeItem":"TimeSlot_activeItem__dYjIZ"};